export default __webpack_public_path__ + "b504bd8ca341687b461c4a4a95fd4c2b.png";